export const SHOP_TAG_OPTIONS = [
  "3D Printing",
  "FDM Specialist",
  "Resin Printing",
  "Prototype Shop",
  "Production Ready",
  "Woodworker",
  "Metal Fabricator",
  "CAD Designer",
  "Laser Cutting",
  "CNC Routing",
  "Finishing",
  "Cosplay Props",
  "Miniatures",
  "Fast Turnaround",
  "Eco Materials",
  "5+ Years Experience",
  "Custom Packaging",
  "Large Format",
];
